import { render, staticRenderFns } from "./UiAlert.vue?vue&type=template&id=1889b96e&scoped=true&"
import script from "./UiAlert.vue?vue&type=script&lang=js&"
export * from "./UiAlert.vue?vue&type=script&lang=js&"
import style0 from "./UiAlert.vue?vue&type=style&index=0&id=1889b96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889b96e",
  null
  
)

export default component.exports